// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PhotoSwipeLightbox from 'photoswipe/lightbox';

export function initializePhotoswipe() {
  const galleries = document.querySelectorAll('[data-action="photoswipe"]');
  galleries.forEach(element => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: element,
      children: 'a',
      pswpModule: () => import('photoswipe'),
    });

    // Pridame gulicky na zobrazenie kde sa nachadzame
    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'bulletsIndicator',
        className: 'pswp__bullets-indicator',
        appendTo: 'wrapper',
        onInit: (el: HTMLElement, pswp: any) => {
          const bullets: HTMLElement[] = [];
          let bullet;
          let prevIndex = -1;

          for (let i = 0; i < pswp.getNumItems(); i++) {
            bullet = document.createElement('div');
            bullet.className = 'pswp__bullet';
            bullet.onclick = e => {
              pswp.goTo(bullets.indexOf(e.target as HTMLElement));
            };
            el.appendChild(bullet);
            bullets.push(bullet);
          }

          pswp.on('change', () => {
            if (prevIndex >= 0) {
              bullets[prevIndex].classList.remove('pswp__bullet--active');
            }
            bullets[pswp.currIndex].classList.add('pswp__bullet--active');
            prevIndex = pswp.currIndex;
          });
        },
      });
    });

    lightbox.init();
  });

  const singles = document.querySelectorAll('[data-action="photoswipe-single"]');
  singles.forEach(element => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: element,
      pswpModule: () => import('photoswipe'),
    });

    lightbox.init();
  });
}
